import React, { FC } from "react";

export const Patients: FC = () => {
  return <div>PATIENTS</div>;
};
